export default __webpack_public_path__ + "static/media/hero.b3c5ed8b.png";